import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'espAllowedExtensions',
})
export class AllowedExtensionsPipe implements PipeTransform {
  transform(value: string[]): string {
    if (!(value.length > 0)) return '';
    return value.map((type) => `.${type}`).join(', ');
  }
}

@Pipe({
  name: 'espWrongExtensionsMessage',
})
export class WrongExtensionsMessagePipe implements PipeTransform {
  transform(value: (string | undefined)[]): string {
    if (!(value.length > 0)) return '';
    const isPlural = value.length > 1;
    return `${isPlural ? 'Extensions' : 'Extension'}: ${[...value].join(', ')} ${isPlural ? 'are' : 'is'} not allowed.`;
  }
}
